interface HeartbeatLoaderProps {
  label?: string
  className?: string
  labelClassName?: string
}

/** Ícone ECG reduzido para uso inline em botões (ex.: "Gerando..."). */
export const HeartbeatIconSmall = ({ className = '' }: { className?: string }) => (
  <span className={`inline-flex shrink-0 ${className}`} aria-hidden>
    <svg viewBox="0 0 48 12" className="h-3 w-8" preserveAspectRatio="none" aria-hidden>
      <path
        className="synap-ecg-track-sm"
        d="M0 6H4L6 5.5L10 6L14 6L18 5.5L22 6H26L30 4L34 7L38 5.5L42 6H48"
      />
      <path
        className="synap-ecg-wave-sm"
        d="M0 6H4L6 5.5L10 6L14 6L18 5.5L22 6H26L30 4L34 7L38 5.5L42 6H48"
      />
    </svg>
  </span>
)

export const HeartbeatLoader = ({ label, className = '', labelClassName }: HeartbeatLoaderProps) => (
  <div className={`flex flex-col items-center gap-3 ${className}`}>
    <div className="relative w-28 overflow-hidden rounded-lg">
      <svg viewBox="0 0 240 60" className="h-10 w-full" preserveAspectRatio="none" aria-hidden>
        <path
          className="synap-ecg-track"
          d="M0 30H14L20 29L28 30L36 30L44 29L52 30H60L68 24L74 35L81 29L88 30H98L106 30L112 24L118 40L125 26L132 30H142L150 29L158 30L166 30L174 27L182 35L190 30H202L210 29L218 30L226 30H240"
        />
        <path
          className="synap-ecg-wave"
          d="M0 30H14L20 29L28 30L36 30L44 29L52 30H60L68 24L74 35L81 29L88 30H98L106 30L112 24L118 40L125 26L132 30H142L150 29L158 30L166 30L174 27L182 35L190 30H202L210 29L218 30L226 30H240"
        />
      </svg>
    </div>
    {label && (
      <span
        className={
          labelClassName ?? 'text-base font-bold text-[var(--color-text-secondary)]'
        }
      >
        {label}
      </span>
    )}
  </div>
)
